export default {
  Confirm: '确定',
  Cancel: '取消',
  'The minimum time length is xxxs!': '最小时长为{{num}}s!',
  'The maximum time length is 50s!': '最大时长为50s！',
  'Online service, no download required': '在线编辑，无需下载',
  'Add up to 20MB file': '文件大小上限为20MB',
  'Support common formats': '支持流行格式',
  'Best for general editing requirements': '解决你的日常编辑需求',
  '0 second wait': '0秒等待',
  'No size limits': '没有文件大小限制',
  'Support 1000+ formats': '支持1000多种格式',
  'Stable processing': '处理稳定',
  'Get access to HitPaw Toolkit!': '查看HitPaw Toolkit！',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    '提供截取、旋转&翻转、调色、变速、加音乐等功能',
  'The easiest video editing software for beginners': '最适合初学者的编辑软件',
  'Remove watermark from videos and images in simple clicks':
    '只需简单点击几下，即可从视频和图像中删除水印',
  'TRY IT FREE': '免费尝试',
  'BUY NOW': '立即购买',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    '视频解析成功！但是目前暂不支持处理大小超过100MB的文件，请',
  'download the video': '下载视频',
  'and then use HitPaw Toolkit to proceed.': '后用Toolkit进行处理。',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    '最多截取10个片段。下载 HitPaw Toolkit 以获取更多功能。',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    '最大支持20MB的文件。下载 HitPaw Toolkit 以获取更多功能。',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    '最小时长为1s！下载 HitPaw Toolkit 以获取更多功能。',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    '最多添加3个视频。下载 HitPaw Toolkit 以获取更多功能。',
  'This format is not supported currently.': '暂不支持该格式。',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    '暂不支持该格式。下载 HitPaw Toolkit 以获取更多功能。',
  'Processing failed. Get HitPaw Toolkit for stable processing.': '生成视频失败！',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': '加载失败！',
  'Are you sure you want to delete it?': '您确定要删除吗？',
  'Failed to extract the audio!': '提取音频失败！',
  'Coming Soon': '即将到来',
  'Learn more': '了解更多',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    '最多添加2个文件。下载 HitPaw Toolkit 以获取更多功能。',
  Download: '下载',
  'Try Again': '再试一次',
  Failed: '失败',
  'Get Started': '开始编辑',
  Start: '开始',
  End: '结束',
  Export: '导出',
  'Your audio is ready!': '你的音频已经准备好了',
  'Download Audio': '下载音频',
  YES: '是的',
  'Export Failed': '导出失败',
  'Error occurs, the file cannot be added': '文件无法添加，添加失败',
  'Support merging audio files at most': '最多支持合并{{num}}个音频文件',
  'Are you sure you want to delete this task?': '是否确认删除任务',
  Processing: '正在处理',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    '不要忘记下载你的文件，它将在24小时后被遗弃',
  Uploading: '上传中',
  'Go Edit': '编辑',
  'Generate Files Successfully!': '生成文件成功!',
  'Your order is being paid...': '您的订单正在支付中',
  'Not yet': '还没有（支付成功）',
  'Payment completed': '付款完成',
  downloadFail: 'Failed to download, please try again.',
  videoReady: '您的动画图片已生成！',
  'Download Without Watermark': ' 下载无水印（视频）',
  'Download As GIF': '下载（视频）为 GIF',
  'Download With Watermark': '下载带水印（视频）',
  'Upload New Photo': '上传新的图片',
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
